import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { dataHooks } from './constants';
import compose from '../../hoc/compose';
import Button from '../button';
import TextLabel from '../textLabel';
import Text from '../text';
import IconButton from '../iconButton';
import Tooltip from '../tooltip';
var SIZES = {
  SMALL: 'small',
  LARGE: 'large'
};

var ActionItem = function ActionItem(props) {
  var title = props.title,
      description = props.description,
      illustration = props.illustration,
      disabledIllustration = props.disabledIllustration,
      onClick = props.onClick,
      dataHook = props.dataHook,
      getClassName = props.getClassName,
      actionIcon = props.actionIcon,
      tooltipContent = props.tooltipContent,
      tooltipInteractive = props.tooltipInteractive,
      shouldTranslate = props.shouldTranslate,
      subLinkText = props.subLinkText,
      onSubLinkClick = props.onSubLinkClick,
      translateIfNeeded = props.translateIfNeeded,
      size = props.size,
      disabled = props.disabled;
  var iconButton = /*#__PURE__*/React.createElement(IconButton, {
    priority: "inverted",
    disabled: disabled
  }, actionIcon);

  var handleClick = function handleClick(e) {
    if (disabled) {
      return;
    }

    onClick(e);
  };

  var handleSubLinkClick = function handleSubLinkClick(event) {
    if (disabled) {
      return;
    }

    event.stopPropagation();
    onSubLinkClick(event);
  };

  var image = disabled ? disabledIllustration : illustration;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classNames(getClassName('wbu-action-item'), {
      'small-size': size === SIZES.SMALL,
      disabled: disabled
    }),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.isValidElement(image) && /*#__PURE__*/React.createElement("div", {
    className: "illustration-wrapper"
  }, image), /*#__PURE__*/React.createElement("div", {
    className: "title-and-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: "wbu-action-item-title",
    className: "title",
    value: title,
    type: size === SIZES.SMALL ? 'T06' : 'T19',
    enableEllipsis: true,
    shouldTranslate: shouldTranslate,
    disabled: disabled
  })), description && /*#__PURE__*/React.createElement("div", {
    className: "description-wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "wbu-action-item-description",
    className: "description",
    size: "small",
    skin: "secondary",
    weight: "thin",
    enableEllipsis: false,
    shouldTranslate: shouldTranslate,
    disabled: disabled
  }, description), ' ', subLinkText && /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    dataHook: "wbu-action-item-sub-link",
    onClick: handleSubLinkClick,
    className: "btn-text inline-link-button"
  }, translateIfNeeded(subLinkText))))), /*#__PURE__*/React.isValidElement(actionIcon) && /*#__PURE__*/React.createElement("div", {
    "data-hook": "wbu-action-item-icon",
    className: "action-icon-wrapper"
  }, tooltipContent ? /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: dataHooks.tooltip,
    marginTop: 4,
    content: tooltipContent,
    shouldTranslate: shouldTranslate,
    interactive: tooltipInteractive
  }, iconButton) : iconButton));
};

ActionItem.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  illustration: PropTypes.node,
  disabledIllustration: PropTypes.node,
  actionIcon: PropTypes.node,
  tooltipContent: PropTypes.node,
  tooltipInteractive: PropTypes.bool,
  onClick: PropTypes.func,
  shouldTranslate: PropTypes.bool,
  subLinkText: PropTypes.string,
  onSubLinkClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(SIZES))
};
ActionItem.defaultProps = {
  className: '',
  tooltipContent: '',
  size: SIZES.LARGE
};
ActionItem.displayName = 'ActionItem';
export default compose(ActionItem);